import { Map } from 'immutable';
import { get, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './private/TaxAuthoritySelectBlock.module.scss';
import TaxAuthoritySelectBlock from './private/TaxAuthoritySelectBlock';
import InfoMessage from 'components/InfoMessage/InfoMessage';
import { defaultMessages } from 'modules/Contacts/components/TaxAuthoritySelect/constants';

export default class TaxAuthoritySelect extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    managements: PropTypes.instanceOf(Map).isRequired,
    taxAuthorities: PropTypes.instanceOf(Map).isRequired,
    taxAuthorityAffiliates: PropTypes.instanceOf(Map).isRequired,
    getManagements: PropTypes.func.isRequired,
    getTaxAuthorities: PropTypes.func.isRequired,
    getTaxAuthorityAffiliates: PropTypes.func.isRequired,
    parent: PropTypes.object,
  };

  static defaultProps = {
    parent: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { parent: currentParent } = prevState;
    const { parent } = nextProps;

    if (parent && !isEqual(parent, currentParent)) {
      return {
        parent: parent,
        selectedManagement: null,
        selectedTaxAuthority: null,
        selectedTaxAuthorityAffiliate: null,
      };
    }
    return null;
  }

  state = {
    selectedManagement: null,
    selectedTaxAuthority: null,
    selectedTaxAuthorityAffiliate: null,
  };

  onSelectManagement = (value) => {
    const { selectedManagement } = this.state;
    const isNewManagement = selectedManagement && get(value, 'id') !== selectedManagement.id;
    let newState = { selectedManagement: value };

    if (isNewManagement) {
      newState.selectedTaxAuthority = null;
      newState.selectedTaxAuthorityAffiliate = null;
    }

    this.setState(newState, () => {
      const { onSelect } = this.props;
      isNewManagement && onSelect(null);
    });
  };

  onSelectTaxAuthority = (value) => {
    const { selectedTaxAuthority } = this.state;
    const isNewTaxAuthority = selectedTaxAuthority && selectedTaxAuthority.id !== value.id;
    let newState = { selectedTaxAuthority: value };

    if (isNewTaxAuthority) {
      newState.selectedTaxAuthorityAffiliate = null;
    }

    this.setState(newState, () => {
      const { onSelect } = this.props;
      onSelect(newState.selectedTaxAuthority);
    });
  };

  onSelectTaxAuthorityAffiliate = (value) => {
    this.setState({ selectedTaxAuthorityAffiliate: value }, () => {
      const { onSelect, parent } = this.props;
      const parentValue = this.state.selectedTaxAuthority
        ? this.state.selectedTaxAuthority
        : parent;
      onSelect(!~value ? parentValue : value);
    });
  };

  renderTaxAuthority = () => {
    const { selectedManagement, selectedTaxAuthority } = this.state;
    const { taxAuthorities, getTaxAuthorities, parent } = this.props;

    if (parent || !selectedManagement) {
      return null;
    }
    if (selectedManagement.visible === false) {
      return this.renderSmMessage('region');
    }

    return (
      <TaxAuthoritySelectBlock
        label="Налоговый орган *"
        parentId={selectedManagement.id}
        taxAuthorities={taxAuthorities}
        selectedTaxAuthority={selectedTaxAuthority}
        getTaxAuthorities={getTaxAuthorities}
        noResultsMessage="Не найдено ни одного налогового органа"
        placeholder="Выберите налоговый орган"
        onSelect={this.onSelectTaxAuthority}
      />
    );
  };

  renderTorm = () => {
    const { selectedTaxAuthority, selectedTaxAuthorityAffiliate } = this.state;
    const { taxAuthorityAffiliates, getTaxAuthorityAffiliates, parent } = this.props;

    if (!selectedTaxAuthority && !parent) {
      return null;
    }

    if (get(selectedTaxAuthority, 'visible') === false) {
      return this.renderSmMessage('ifns');
    }
    if (get(parent, 'visible') === false) {
      return this.renderSmMessage('ifns');
    }

    return (
      <>
        <TaxAuthoritySelectBlock
          label="Территориально обособленное рабочее место (ТОРМ) ФНС России"
          parentId={parent ? parent.id : selectedTaxAuthority.id}
          taxAuthorities={taxAuthorityAffiliates}
          selectedTaxAuthority={selectedTaxAuthorityAffiliate}
          getTaxAuthorities={getTaxAuthorityAffiliates}
          placeholder="Выберите территориально обособленное рабочее место (ТОРМ) ФНС России"
          hasEmptyValue={true}
          onSelect={this.onSelectTaxAuthorityAffiliate}
        />
        {selectedTaxAuthorityAffiliate &&
          get(selectedTaxAuthorityAffiliate, 'visible') === false &&
          this.renderSmMessage('ifns')}
      </>
    );
  };

  renderSmMessage = (type) => {
    return (
      <InfoMessage type={'error'} className={styles.smMessage}>
        {defaultMessages[type]}
      </InfoMessage>
    );
  };

  render = () => {
    const { selectedManagement } = this.state;
    const { managements, getManagements, parent } = this.props;

    return (
      <div>
        {!parent ? (
          <TaxAuthoritySelectBlock
            label="Регион (управление) *"
            taxAuthorities={managements}
            selectedTaxAuthority={selectedManagement}
            getTaxAuthorities={getManagements}
            noResultsMessage="Не найдено ни одного управления"
            placeholder="Выберите регион (управление)"
            onSelect={this.onSelectManagement}
          />
        ) : null}
        {this.renderTaxAuthority()}
        {this.renderTorm()}
      </div>
    );
  };
}
